import { Card, Col, Row, Statistic, Typography } from 'antd'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { getWorkspaceBillingUsageMock } from './mockUsage'

type Props = {
  workspaceId: number
}

const { Paragraph } = Typography

export const WorkspaceBillingCard = ({ workspaceId }: Props) => {
  const { t } = useTranslation()
  const usage = useMemo(
    () => getWorkspaceBillingUsageMock(workspaceId),
    [workspaceId]
  )

  return (
    <Card variant="outlined">
      <Paragraph type="secondary" style={{ marginBottom: 16 }}>
        {t('workspace.billing.mockNotice')}
      </Paragraph>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} lg={6}>
          <Statistic
            title={t('workspace.billing.period')}
            value={usage.periodLabel}
          />
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Statistic
            title={t('workspace.billing.apiRequests')}
            value={usage.apiRequests}
          />
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Statistic
            title={t('workspace.billing.storageGb')}
            value={usage.storageGb}
            suffix="GB"
          />
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Statistic
            title={t('workspace.billing.aiTokensUsed')}
            value={usage.aiTokensUsed}
          />
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Statistic
            title={t('workspace.billing.aiTokensLimit')}
            value={usage.aiTokensLimit}
          />
        </Col>
      </Row>
    </Card>
  )
}
